import AssociationProxy from './association_proxy';

export default class AssociationInjector {
  constructor(entitySpace, associations, collectionConstructor) {
    this.inject                = this.inject.bind(this);
    this.entitySpace           = entitySpace;
    this.associations          = associations;
    this.collectionConstructor = collectionConstructor;
  }

  static for(entitySpace, associations, collectionConstructor) {
    return new (this)(entitySpace, associations, collectionConstructor);
  }

  withSpace(entitySpace) {
    return new this.constructor(entitySpace, this.associations, this.collectionConstructor);
  }

  inject(entity) {
    if (entity.associations?.associationInjector !== this) {
      entity.associations = new AssociationProxy(entity, this);
    }

    return entity;
  }
}
